// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export default interface IGitHubClient {
  authToken?: string;
  userName?: string;
}
